import * as React from 'react';
import styled from 'styled-components'
import {ConstColor} from "../../../../config/styles_const/styles_const";
import {Long} from "protobufjs";

interface IProps {
    unReadCount: number | Long;
}

const LabelUnread: React.FC<IProps> = (props) => {

    const {unReadCount } = props;

    const maxedUnreadCount = unReadCount < 100 ? unReadCount : "99+";

    return (
        <Wrapper>
            <LabelUnreadDefault data-badge={maxedUnreadCount} />
        </Wrapper>

    )

};

const Wrapper = styled.div`
`;

const LabelUnreadDefault = styled.span`
    position: relative;
    &[data-badge]:after {
        content:attr(data-badge);
        position:absolute;
        top: -10px;
        left: -15px;
        font-weight: 900;
        font-size: 8px;
        background: ${ConstColor.Corporate};
        color: ${ConstColor.White};
        border-radius: 30px;
        line-height: 12px;
        white-space: nowrap;
        padding: 2px 5px;
    }
`;

export default LabelUnread;


// WEBPACK FOOTER //
// ./src/presentation/common/atom/label/label_unread.tsx